export const TREND_TYPE = {
  STORE: 1,
  CHAIN: 2
} as const
